export const useStateChannelDetailsStore = defineStore('stateChannelDetails', () => {
  const stateChannelDetails = ref(null)
  const stateChannelTransactions = ref(null)
  const stateChannelTransactionsCount = ref(null)

  async function fetchStateChannelDetails(id) {
    stateChannelDetails.value = null
    const data = await $fetch(`/api/channels/${id}`)
    if (data.error === 400) {
      throw showError({
        data: {
          entityId: id,
          entityName: 'State Channel',
        },
        statusMessage: 'EntityDetailsNotFound',
      })
    } else {
      stateChannelDetails.value = data
    }
  }

  async function fetchStateChannelTransactions({ id, queryParameters, limit } = {}) {
    stateChannelTransactions.value = null
    stateChannelTransactions.value = await $fetch('/api/channels/transactions', {
      params: { queryParameters, direction: 'backward', channel: id, limit },
    })
  }

  return {
    stateChannelDetails,
    stateChannelTransactions,
    stateChannelTransactionsCount,
    fetchStateChannelDetails,
    fetchStateChannelTransactions,
  }
})
